import PathName from "../RoutePath";
import ManuPage from "../../Views/Menu/MenuPage";
import LoginPage from "../../Views/Login/LoginPage";
import CategoryPage from "../../Views/Menu/CategoryPage";
import AboutUs from "../../Views/FooterScreens/AboutUs";
import PrivacyPolicy from "../../Views/FooterScreens/PrivacyPolicy";
import TermsConditions from "../../Views/FooterScreens/TermsConditions";
import MitaoBhook from "../../Views/FooterScreens/MitaoBhook";
import CareersPage from "../../Views/FooterScreens/CareersPage";
import ContactUs from "../../Views/FooterScreens/ContactUs";
import Bucket from "../../Views/Cart/Bucket";
import ProfilePage from "../../Views/ProfileInfo/ProfilePage";
import PaymentMethod from "../../Views/Cart/PaymentMethod";
import MobilePaymentMethod from "../../Views/Cart/mobileCard";
import StoreLocator from "../../Views/StoreLocator/StoreLocator";
import TrackOrder from "../../Views/TrackOrder/TrackOrder";
import Item from "../../Views/Cart/item";
import OrderHistory from "../../Views/ProfileInfo/OrderHistory";
import FeedBack from "../../Views/FooterScreens/FeedBack";
import AddFavourite from "../../Views/ProfileInfo/AddFavourite";
import SaveAddress from "../../Views/ProfileInfo/SaveAddress";
import SaveCards from "../../Views/ProfileInfo/SaveCards";
import MyDetail from "../../Views/ProfileInfo/MyDetail";
import MitaoBhookScholarship from "../../Views/FooterScreens/MitaoBhookScholarship";
import GuestLogin from "../../Views/Cart/GuestLogin";
import SignUp from "../../Views/Login/SignUp";
import ChangePassword from "../../Views/ProfileInfo/ChangePassword";
import RateUS from "../../Views/RateUs/RateUs";
import GuestDetails from "../../Views/Cart/GuestDetails";
import CampaignRedirection from "../../Views/CampaignRedirection";
import DineinRedirection from "../../Views/DineinRedirection";

const authRoutes = [
  { path: PathName.ManuePage, component: ManuPage },
  { path: PathName.LoginPage, component: LoginPage },
  { path: PathName.CategoryPage, component: CategoryPage },
  { path: PathName.AboutUs, component: AboutUs },
  { path: PathName.PrivacyPolicy, component: PrivacyPolicy },
  { path: PathName.TermsAndConditions, component: TermsConditions },
  // { path: PathName.MitaoBhook, component: MitaoBhook },
  { path: PathName.CareersPage, component: CareersPage },
  // { path: PathName.ContactUs, component: ContactUs },
  { path: PathName.Bucket, component: Bucket },
  { path: PathName.ProfilePage, component: ProfilePage },
  { path: PathName.SaveCards, component: SaveCards },
  { path: PathName.PaymentMethod, component: PaymentMethod },
  { path: PathName.MobilePaymentMethod, component: MobilePaymentMethod },
  { path: PathName.StoreLocator, component: StoreLocator },
  { path: PathName.TrackOrder, component: TrackOrder },
  { path: PathName.OrderHistory, component: OrderHistory },
  { path: PathName.FeedBack, component: FeedBack },
  { path: PathName.AddFavorite, component: AddFavourite },
  { path: PathName.MyDetail, component: MyDetail },
  // { path: PathName.MitaoBhookScholarship, component: MitaoBhookScholarship },
  { path: PathName.GuestLogin, component: GuestDetails },
  { path: PathName.SignUp, component: SignUp },
  { path: PathName.ChangePassword, component: ChangePassword },
  { path: PathName.RateUS, component: RateUS },
  { path: PathName.CampaignRedirection, component: CampaignRedirection },
  { path: PathName.DineinRedirection, component: DineinRedirection },

  { path: PathName.Item, component: Item },
];

process.env.REACT_APP_DELIVERY_ENABLE == "true" && authRoutes.push({ path: PathName.SaveAddress, component: SaveAddress })

export default authRoutes;
